import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";
import { _3_DAYS } from "../../../constants/durations";

export async function fetchProviderContacts(providerId: string) {
  const { data, error } = await apiClient
    .from('provider_contacts')
    .select(`*`)
    .eq('provider_id', providerId)
    .order('name', { ascending: true });

  if (error) {
    throw error;
  }

  return data;
}

export default function useGetProviderContacts(providerId: string | undefined, enabled = true) {

  return useQuery({
    queryKey: keys.getProviderContacts(providerId!),
    queryFn: () => fetchProviderContacts(providerId!),
    enabled: enabled && !!providerId,
    staleTime: _3_DAYS
  })
}
